import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { COMPANY } from "@/config";

const HERO_IMG = "https://images.pexels.com/photos/33551482/pexels-photo-33551482.jpeg";

export const Hero = () => {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img src={HERO_IMG} alt="Modern plat dak tegen blauwe lucht" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/75" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/60 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-12 w-full pt-24 pb-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-sefco-blue" />
            <span className="text-xs sm:text-sm uppercase tracking-[0.25em] text-sefco-blue font-medium">
              Dakdekker · 25+ jaar ervaring
            </span>
          </div>

          <h1 className="font-heading font-black text-white text-4xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
            Sefco: Specialist in{" "}
            <span className="text-sefco-blue">Platte Daken</span> & Dakisolatie
          </h1>

          <p className="mt-8 text-base sm:text-lg text-zinc-300 max-w-2xl leading-relaxed">
            Meer dan 25 jaar ervaring in grote renovatie- en isolatieprojecten voor
            woningen, appartementen en bedrijfspanden.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-button"
              onClick={() => scrollTo("#contact")}
              className="group inline-flex items-center justify-center gap-3 bg-sefco-blue hover:bg-sefco-blueHover text-white font-bold text-base px-8 py-4 tracking-wide transition-colors"
            >
              Vraag een vrijblijvende offerte aan
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              data-testid="hero-services-button"
              onClick={() => scrollTo("#diensten")}
              className="inline-flex items-center justify-center gap-3 border border-white/40 hover:bg-white hover:text-black text-white font-bold text-base px-8 py-4 tracking-wide transition-colors"
            >
              <Phone size={18} /> Onze diensten
            </button>
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 border-t border-white/10 bg-black/40 backdrop-blur-sm">
        <div className="mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-3 divide-x divide-white/10">
          {[
            { k: "25+", v: "Jaar ervaring" },
            { k: "100%", v: "Waterdicht" },
            { k: "100 m²+", v: "Grote projecten" },
          ].map((s) => (
            <div key={s.v} className="py-5 px-2 text-center sm:text-left">
              <div className="font-heading font-black text-2xl sm:text-3xl text-white">{s.k}</div>
              <div className="text-xs sm:text-sm text-zinc-400 uppercase tracking-wider">{s.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
